import { Button, DataGrid, LoadPanel } from "devextreme-react";
import AuthFileUploader from "../../../common/AuthFileUploader";
import {
  Column,
  ColumnChooser,
  ColumnFixing,
  Editing,
  Export,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Item,
  Lookup,
  Paging,
  Popup,
  Position,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  Summary,
  Texts,
  Toolbar,
  ToolbarItem,
  TotalItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { init, updateAll } from "./Redux/siteVisit";
import TaskForm from "./TaskForm";
import axios from "axios";
import { detailedCmt, siteVisitTask } from "../data";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import { notifyMsg } from "../../../common/notify";

import "./index.css";

export default function SiteVisitGrid(props) {
  const {
    sales,
    siteVisitTimeGridRef,
    siteVisitFullScreen,
    setSiteVisitFullScreen,
  } = props;

  const dispatch = useDispatch();

  const siteVisit = useSelector((state) => state.siteVisit);
  const userInfo = useSelector((state) => state.userInfo);

  const taskFormRef = useRef(null);
  const siteVisitGridRef = useRef(null);

  const [taskPopupVisible, setTaskPopupVisible] = useState(false);
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["contrNo", "siteNo", "SEQ"],
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteVisit/${sales.contrNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios
            .post(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteVisit/${sales.contrNo}/${values.siteNo}`,
              values
            )
            .catch(function (error) {
              if (error) {
                notifyMsg(
                  "에러가 발생했습니다. 관리자에게 문의해주세요.",
                  "error"
                );
              }
            });
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteVisit/${key.contrNo}/${key.siteNo}/${key.SEQ}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteVisit/${key.contrNo}/${key.siteNo}/${key.SEQ}`
          );
        },
      })
    );
  }, [sales.contrNo]);

  const contentRender = useCallback(() => {
    return (
      <TaskForm
        contrNo={sales.contrNo}
        siteVisit={siteVisit}
        taskFormRef={taskFormRef}
      />
    );
  }, [siteVisit]);

  const onInitNewRow = () => {
    dispatch(init());

    setTaskPopupVisible(true);
  };

  const onSaveClick = useCallback(() => {
    if (taskFormRef.current.instance.validate().isValid) {
      setTaskPopupVisible(false);

      if (siteVisit.action == "insert") {
        siteVisitGridRef.current.instance
          .getDataSource()
          .store()
          .insert(siteVisit)
          .then(() => {
            siteVisitGridRef.current.instance.refresh();
            siteVisitTimeGridRef.current.instance.refresh();
          });
      } else {
        siteVisitGridRef.current.instance
          .getDataSource()
          .store()
          .update(
            {
              contrNo: siteVisit.contrNo,
              siteNo: siteVisit.siteNo,
              SEQ: siteVisit.SEQ,
            },
            siteVisit
          )
          .then(() => {
            siteVisitGridRef.current.instance.refresh();
            siteVisitTimeGridRef.current.instance.refresh();
          });
      }
    }
  }, [siteVisit]);

  const headerCellRender = () => {
    return (
      <div>
        Site Information <br /> (Site No.-Site Name-PI Name)
      </div>
    );
  };

  const calculateCellValue = (data) =>
    // `${data.siteNo}-${data.LAB_NAME}-${data.INSPCT_MANAGER_NAME}`;
    `${data.siteNo}-${data.yadmNm}-${data.INSPCT_MANAGER_NAME}`;

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
        action: "update",
      })
    );

    setTaskPopupVisible(true);
  };

  const onSaved = (e) => {
    siteVisitTimeGridRef.current.instance.refresh();
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#A9D08E";
    }
  };

  const onExporting = (e) => {
    siteVisitGridRef.current.instance.clearFilter();

    e.component.beginUpdate();
    e.component.columnOption("contrNo", "visible", true);
    e.component.columnOption("siteNo", "visible", true);
    e.component.columnOption("SEQ", "visible", true);

    const workbook = new Workbook();

    workbook.creator = "BeTree";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Site Visits");
    // const worksheet2 = workbook.addWorksheet("test");

    worksheet.properties.defaultRowHeight = 13.5;

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        excelCell.font = {
          size: 10,
        };

        excelCell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        if (gridCell.rowType === "data") {
          switch (gridCell.column.dataField) {
            case "contrNo":
            case "siteNo":
            case "SEQ":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FBFBFBF" },
              };
              break;
          }
        } else if (gridCell.rowType === "header") {
          excelCell.font = {
            bold: true,
            size: 10,
          };

          excelCell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FA9D08E",
            },
          };

          switch (gridCell.column.dataField) {
            case "contrNo":
              worksheet.getColumn(excelCell.col).width = 15;
              break;
            case "siteNo":
            case "SEQ":
              worksheet.getColumn(excelCell.col).width = 7;
              break;
            case "siteInfo":
              worksheet.getColumn(excelCell.col).width = 50;
              break;
            case "siteLoc":
            case "task":
            case "cmt":
              worksheet.getColumn(excelCell.col).width = 30;
              break;
            default:
              worksheet.getColumn(excelCell.col).width = 15;
              break;
          }
        }

        worksheet.getCell("F2").note = {
          texts: [
            {
              text: "Pre-Study Visits (PSV) - Remote\n",
            },
            {
              text: "Pre-Study Visits (PSV) - On-site\n",
            },
            {
              text: "Site Initiation Visit (SIV) - Remote\n",
            },
            {
              text: "Site Initiation Visit (SIV) - On-site\n",
            },
            {
              text: "Site Monitoring Visit (SMV) - Remote\n",
            },
            {
              text: "Site Monitoring Visit (SMV) - On-site\n",
            },
            {
              text: "Site Close-out Visit (SCV) - Remote\n",
            },
            {
              text: "Site Close-out Visit (SCV) - On-site",
            },
            {
              text: "Site Additional Visit (SAV) - Remote",
            },
            {
              text: "Site Additional Visit (SAV) - On-site",
            },
          ],

          margins: {
            insetmode: "custom",
            inset: [0.25, 0.25, 0.35, 0.35],
          },
          protection: {
            locked: true,
            lockText: false,
          },
          editAs: "twoCells",
        };

        worksheet.getCell("I2").note = {
          texts: [
            {
              text: "초기심의(Initial)\n",
            },
            {
              text: "변경심의(Amendment)\n",
            },
            {
              text: "지속심의(Interim)\n",
            },
            {
              text: "종료보고(Completion)\n",
            },
            {
              text: "결과보고(CSR)\n",
            },
          ],
          margins: {
            insetmode: "custom",
            inset: [0.25, 0.25, 0.35, 0.35],
          },
          protection: {
            locked: true,
            lockText: false,
          },
          editAs: "twoCells",
        };
      },
    })
      .then(() =>
        exportDataGrid({
          worksheet,
          component: siteVisitTimeGridRef.current.instance,
          topLeftCell: { row: 3, column: 13 },
          autoFilterEnabled: true,
          customizeCell: ({ gridCell, excelCell }) => {
            excelCell.font = {
              size: 10,
            };

            excelCell.border = {
              top: {
                style: "thin",
              },
              left: {
                style: "thin",
              },
              bottom: {
                style: "thin",
              },
              right: {
                style: "thin",
              },
            };

            if (gridCell.rowType === "header") {
              excelCell.font = {
                bold: true,
                size: 10,
              };

              excelCell.alignment = {
                vertical: "middle",
                horizontal: "center",
              };
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FA9D08E",
                },
              };

              switch (gridCell.column.dataField) {
                case "siteInfo":
                  worksheet.getColumn(excelCell.col).width = 50;
                  break;
                default:
                  worksheet.getColumn(excelCell.col).width = 15;
                  break;
              }
            }
          },
        })
      )
      .then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], {
              type: "application/octet-stream",
            }),
            `Site Visits_${sales.contrNo}.xlsx`
          );
        });

        e.component.columnOption("contrNo", "visible", false);
        e.component.columnOption("siteNo", "visible", false);
        e.component.columnOption("SEQ", "visible", false);
        e.component.endUpdate();

        notifyMsg("Site Visit 파일이 다운로드 되었습니다.", "success");
      });
  };

  const onHidingLoadPanel = () => {
    setLoadPanelVisible(false);
  };

  const onUploadStarted = (e) => {
    setLoadPanelVisible(true);
  };

  const onUploaded = (e) => {
    setLoadPanelVisible(false);

    notifyMsg("Site Visit 파일이 업로드되었습니다.", "success");

    siteVisitGridRef.current.instance.refresh();
    siteVisitTimeGridRef.current.instance.refresh();
  };

  const onUploadError = (e) => {
    setLoadPanelVisible(false);

    if (e.error.response) {
      notifyMsg(JSON.parse(e.error.response).error.Message, "error");
    } else {
      notifyMsg("에러가 발생했습니다. 관리자에게 문의해주세요.", "error");
    }
  };

  const onMinMaxIconClick = () => {
    setSiteVisitFullScreen(!siteVisitFullScreen);
  };

  return (
    <>
      <DataGrid
        id="siteVisitGrid"
        ref={siteVisitGridRef}
        dataSource={dataSource}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        rowAlternationEnabled={true}
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        width={"100%"}
        height={"100%"}
        repaintChangesOnly={true}
        highlightChanges={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        style={{
          maxHeight: "800px",
        }}
        onInitNewRow={onInitNewRow}
        onEditingStart={onEditingStart}
        onSaved={onSaved}
        onCellPrepared={onCellPrepared}
        onExporting={onExporting}
      >
        {/* <GroupPanel visible={true} /> */}
        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
        <Grouping autoExpandAll={true} />
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
          showScrollbar={"always"}
        />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Paging enabled={false} />
        <Sorting mode={"multiple"} />
        <Selection mode={"single"} />
        <ColumnFixing enabled={true} />
        <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
          <Position
            my={"right top"}
            at={"right bottom"}
            of={".dx-datagrid-column-chooser-button"}
          />
        </ColumnChooser>

        <Editing
          refreshMode={"reshape"}
          mode={"popup"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          <Texts
            confirmDeleteMessage={
              "Are you sure want to delete this task of site visit?"
            }
          />
          <Popup
            visible={taskPopupVisible}
            showTitle={true}
            title={
              siteVisit.action == "insert" ? "Create a Task" : "Edit the Task"
            }
            height={"auto"}
            showCloseButton={true}
            contentRender={contentRender}
          >
            <ToolbarItem
              widget={"dxButton"}
              toolbar={"top"}
              location={"after"}
              options={{
                icon: "save",
                type: "normal",
                stylingMode: "contained",
                onClick: onSaveClick,
              }}
            />
          </Popup>
        </Editing>

        <Export enabled={true} />

        <Toolbar>
          <Item location={"before"}>
            <div className="file-uploader-block">
              <AuthFileUploader
                id="siteVisitFileUploader"
                width={350}
                uploadMode="instantly"
                uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/siteVisit?employeeNo=${userInfo.employeeNo}`}
                allowedFileExtensions={[".xlsx"]}
                showFileList={false}
                onUploadStarted={onUploadStarted}
                onUploaded={onUploaded}
                onUploadError={onUploadError}
              />
            </div>
          </Item>
          <Item location="after" name={"addRowButton"} />
          <Item name={"exportButton"} />
          <Item name={"columnChooserButton"} />
          <Item location={"after"}>
            <Button
              onClick={onMinMaxIconClick}
              icon={
                siteVisitFullScreen
                  ? `fa-solid fa-minimize`
                  : `fa-solid fa-maximize`
              }
            />
          </Item>
          <Item name={"searchPanel"} />
        </Toolbar>

        <Column
          dataField={"contrNo"}
          caption={"Contract No."}
          visible={false}
        />
        <Column dataField={"siteNo"} caption={"Site No."} visible={false} />
        <Column dataField={"SEQ"} caption={"SEQ"} visible={false} />

        <Column
          dataField={"no"}
          caption={"No."}
          dataType={"number"}
          width={60}
          allowEditing={false}
        />

        <Column
          dataField={"siteInfo"}
          // groupIndex={1}
          dataType={"string"}
          width={400}
          headerCellRender={headerCellRender}
          calculateCellValue={calculateCellValue}
        />
        <Column
          dataField={"siteLoc"}
          caption={"Site Location"}
          dataType={"string"}
        />
        <Column caption={"Site Visit Activities"}>
          <Column
            dataField={"task"}
            caption={"Task"}
            dataType={"string"}
            width={250}
          >
            <Lookup
              dataSource={siteVisitTask}
              valueExpr={"id"}
              displayExpr={"name"}
            />
          </Column>
          <Column
            dataField={"visitDate"}
            caption={"Visit Date"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
          />
          <Column
            dataField={"visitRptSedDate"}
            caption={"Visit Report Sending Date"}
            dataType={"date"}
            format={"yyyy-MM-dd"}
            width={100}
          />
          <Column
            dataField={"detailedCmt"}
            caption={"Detailed Comment"}
            dataType={"string"}
            width={200}
          >
            <Lookup
              dataSource={detailedCmt}
              valueExpr={"id"}
              displayExpr={"name"}
            />
          </Column>
          <Column dataField={"cmt"} caption={"Comment"} dataType={"string"} />
        </Column>

        <Summary>
          <TotalItem
            column={"visitDate"}
            summaryType={"count"}
            displayFormat={"{0}"}
          />
        </Summary>
      </DataGrid>
      <LoadPanel
        shadingColor="rgba(0, 0, 0, 0.4)"
        position={{
          of: "#siteVisitGrid",
        }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        onHiding={onHidingLoadPanel}
      />
    </>
  );
}
